import { render, staticRenderFns } from "./PrivateConsultingInfo.vue?vue&type=template&id=4eb572c1&scoped=true"
import script from "./PrivateConsultingInfo.vue?vue&type=script&lang=js"
export * from "./PrivateConsultingInfo.vue?vue&type=script&lang=js"
import style0 from "./PrivateConsultingInfo.vue?vue&type=style&index=0&id=4eb572c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb572c1",
  null
  
)

export default component.exports